var exports = {
  "R": "heading__B2udY_",
  "q": "listContainer__OSNfAK",
};

module.exports = exports;
